import React from "react";
import { allRatings } from "./CustomerReviewHelper";
import { FilteredBy } from "./reviewModels";

interface RatingsFilterProps {
  onRatingChange: (filteredBy: FilteredBy, gtmLabel?: string) => void;
  filteredBy: FilteredBy;
}

const RatingsFilter = ({ onRatingChange, filteredBy }: RatingsFilterProps) => {
  const ratingChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const value = selectedOption?.value;

    onRatingChange({ ...filteredBy, rating: value });
  };

  return (
    <div className="float-left ml-3.5 mt-[7px] xs:mt-0">
      <label
        className="review-aggregation__label block"
        htmlFor="filterByRating"
      >
        Filter By Rating
      </label>
      <select
        className="suffix_dropdown configure item_number text-sm w-[195px] xxxs:w-[155px] xxs:w-[165px] xsl:w-[195px]"
        id="filterByRating"
        name="FilterByRating"
        onChange={ratingChangeHandler}
        data-testid="review-rating-filter-dropdown"
        value={filteredBy.rating}
      >
        <option value={allRatings}>All Ratings</option>
        <option value="5">5 Stars</option>
        <option value="4">4 Stars</option>
        <option value="3">3 Stars</option>
        <option value="2">2 Stars</option>
        <option value="1">1 Star</option>
      </select>
    </div>
  );
};

export default RatingsFilter;
